
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const TaskDefCrudService = function(props: 
  CrudServiceProps<api.TaskDef,string>
) {
  
  return CrudApiService<api.TaskDef,string>({...props, api: api, entityName: 'TaskDef'});

};